import { LitElement, html, css, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";

import { navigateOnClick } from "../../../common/router/app-navigation.js";
import { parteiPfad } from "../../../config/navigation.js";

/**
 * DIE Regel 6.5 des Parteien-Konzepts, an einer Stelle: Wo ein kuratierter
 * Partei-Slug vorliegt, ist der Kurzname ein Weg auf die Parteiseite; ohne
 * Slug bleibt er Text — sichtbar, nicht geraten. Sieben Stellen im Portal
 * setzen diesen Baustein ein und entscheiden nichts selbst.
 *
 * Der Farbpunkt ist optional (Zeilen, die schon einen Balken haben, brauchen
 * keinen zweiten Farbträger). Die Typografie erbt der Baustein vom Umfeld —
 * er ist ein Wort, kein Kasten.
 */
@customElement("app-partei-link")
export class AppParteiLink extends LitElement {
  /** Kuratierter Slug; leer = kein Link. */
  @property() slug = "";

  /** Der Text, wie das Umfeld ihn zeigt (Kurzname, Wortlaut). */
  @property() text = "";

  /** Parteifarbe für den Punkt; ohne Angabe kein Punkt. */
  @property() farbe = "";

  static override styles = css`
    :host {
      display: inline;
    }
    a {
      color: inherit;
      text-decoration: none;
      text-decoration-color: var(--portal-akzent);
    }
    a:hover,
    a:focus-visible {
      text-decoration: underline;
    }
    a:focus-visible {
      outline: 2px solid var(--portal-akzent);
      outline-offset: 2px;
    }
    .punkt {
      display: inline-block;
      width: var(--portal-punkt);
      height: var(--portal-punkt);
      border-radius: 50%;
      margin-right: 0.35em;
      vertical-align: baseline;
    }
  `;

  override render() {
    const punkt = this.farbe
      ? html`<span class="punkt" style="background:${this.farbe}" aria-hidden="true"></span>`
      : nothing;
    if (!this.slug) return html`${punkt}${this.text}`;
    const pfad = parteiPfad(this.slug);
    return html`<a href=${pfad} @click=${(e: Event) => navigateOnClick(e, pfad)}
      >${punkt}${this.text}</a
    >`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "app-partei-link": AppParteiLink;
  }
}
